import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import merge from "lodash/merge";
import { adjustServerTimestamp, DATE_CONSIDERATIONS, formatTimeString, handle, isBothTimeEqual, isFirstParamTimeBigEqual, NRO_STATUS_TYPES } from "@dp/common";
import moment from "moment-timezone";
import i18next from "i18next";

var Common = /*#__PURE__*/function () {
  function Common(config, axios, cart) {
    var _this = this;

    _classCallCheck(this, Common);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "cart", void 0);

    _defineProperty(this, "processWaitlistOperatingStatus", function (restDateTimeInTZ, waitListInformation, waitListData) {
      var endDayOfWeek = waitListData.endDayOfWeek,
          startDayOfWeek = waitListData.startDayOfWeek,
          startTime = waitListData.startTime,
          endTime = waitListData.endTime;
      var restDayInTZ = restDateTimeInTZ.day() + 1;

      if (restDayInTZ >= startDayOfWeek && restDayInTZ <= endDayOfWeek) {
        var waitlistOpeningTime = formatTimeString(startTime);
        var waitlistClosingTime = formatTimeString(endTime);
        var restTimeInTZString = restDateTimeInTZ.format(DATE_CONSIDERATIONS.TIME_FORMAT);
        var isRestTimeBeforeOpening = isFirstParamTimeBigEqual(waitlistOpeningTime, restTimeInTZString);
        var isRestTimeAfterClosing = isFirstParamTimeBigEqual(restTimeInTZString, waitlistClosingTime, true);
        waitListInformation.isAvailable = !isRestTimeBeforeOpening && !isRestTimeAfterClosing;
        waitListInformation.startTime = waitlistOpeningTime;
        waitListInformation.endTime = waitlistClosingTime;
      }
    });

    _defineProperty(this, "processWaitlistInformation", function (restDateTimeInTZ, restaurantDetails) {
      var waitListInformation = {};
      waitListInformation.hasWaitlistHourCode = false;
      var restSplHrsInfo = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restSplHrsInfo) || [];
      var siteLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.siteLevelSplHours) || [];
      var locationLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.locationLevelSplHours) || [];

      if (restaurantDetails !== null && restaurantDetails !== void 0 && restaurantDetails.webAhead) {
        [].concat(_toConsumableArray(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restaurantWLHours), _toConsumableArray(restSplHrsInfo), _toConsumableArray(siteLevelSplHours), _toConsumableArray(locationLevelSplHours)).forEach(function (waitList) {
          var _waitList$hourCode;

          if ((waitList === null || waitList === void 0 ? void 0 : (_waitList$hourCode = waitList.hourCode) === null || _waitList$hourCode === void 0 ? void 0 : _waitList$hourCode.hourCode) === "WL") {
            waitListInformation.hasWaitlistHourCode = true;

            _this.processWaitlistOperatingStatus(restDateTimeInTZ, waitListInformation, waitList);
          }
        });
        var partySize = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restDefaultPartySize;
        var waitListDetails = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.wait_lits_details;
        var waitListLength = waitListDetails === null || waitListDetails === void 0 ? void 0 : waitListDetails.length;

        for (var idx = 0; idx < waitListLength; idx++) {
          var _waitListDetails$idx;

          if (partySize === +((_waitListDetails$idx = waitListDetails[idx]) === null || _waitListDetails$idx === void 0 ? void 0 : _waitListDetails$idx.partySize)) {
            var _waitListDetails$idx2 = waitListDetails[idx],
                highQuote = _waitListDetails$idx2.highQuote,
                lowQuote = _waitListDetails$idx2.lowQuote;
            waitListInformation.lowQuote = lowQuote;
            waitListInformation.highQuote = highQuote;
            break;
          }
        }
      } else {
        waitListInformation.isAvailable = false;
      }

      return waitListInformation;
    });

    _defineProperty(this, "checkIfClosingSoon", function (localTimestamp, restaurantEndTime) {
      var considerNextDayForRestaurantEndTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var CLOSING_BUFFER_MINS = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
      var considerationDate = DATE_CONSIDERATIONS.CHECKING_DATE;
      var adjustedTS = adjustServerTimestamp(localTimestamp === null || localTimestamp === void 0 ? void 0 : localTimestamp.time);
      var restDateTimeInTZ = moment(adjustedTS).format(DATE_CONSIDERATIONS.TIME_FORMAT);
      var restaurantClosingTime = formatTimeString(restaurantEndTime);
      var CLOSING_BUFFER_MS = CLOSING_BUFFER_MINS * 60 * 1000;
      var tempDate01 = moment("".concat(considerationDate, " ").concat(restDateTimeInTZ), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);

      if (considerNextDayForRestaurantEndTime && restaurantClosingTime.slice(-2, -1).toUpperCase() === "A") {
        considerationDate = "2022-01-03";
      }

      var tempDate02 = moment("".concat(considerationDate, " ").concat(restaurantClosingTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT);
      return tempDate01.valueOf() >= tempDate02.valueOf() - CLOSING_BUFFER_MS && tempDate01.valueOf() < tempDate02.valueOf();
    });

    _defineProperty(this, "checkIfRestaurantClosed", function (localTimestamp, restaurantStartTime, restaurantEndTime) {
      var adjustedTS = adjustServerTimestamp(localTimestamp === null || localTimestamp === void 0 ? void 0 : localTimestamp.time);
      var restDateTimeInTZ = moment(adjustedTS);
      var restaurantOpeningTime = formatTimeString(restaurantStartTime);
      var restaurantClosingTime = formatTimeString(restaurantEndTime);
      var restTimeInTZString = restDateTimeInTZ.format(DATE_CONSIDERATIONS.TIME_FORMAT);
      var isRestaurant24HrsOpen = isBothTimeEqual(restaurantOpeningTime, restaurantClosingTime);
      var isRestTimeBeforeOpening = isRestaurant24HrsOpen ? false : isFirstParamTimeBigEqual(restaurantOpeningTime, restTimeInTZString);
      var isRestTimeAfterClosing = isRestaurant24HrsOpen ? false : isFirstParamTimeBigEqual(restTimeInTZString, restaurantClosingTime, true);
      var isRestaurantClosed = isRestTimeBeforeOpening || isRestTimeAfterClosing;
      return {
        isRestaurantClosed: isRestaurantClosed,
        isRestTimeBeforeOpening: isRestTimeBeforeOpening,
        isRestTimeAfterClosing: isRestTimeAfterClosing,
        restaurantOpeningTime: restaurantOpeningTime,
        restaurantClosingTime: restaurantClosingTime,
        restTimeInTZString: restTimeInTZString
      };
    });

    _defineProperty(this, "secondThresholdComingSoonStatus", function (localTimestamp, openDateTimestamp, isComingSoon) {
      var adjustedRestTS = adjustServerTimestamp(localTimestamp === null || localTimestamp === void 0 ? void 0 : localTimestamp.time);
      var adjustedOpenDateTS = adjustServerTimestamp(openDateTimestamp === null || openDateTimestamp === void 0 ? void 0 : openDateTimestamp.time);
      var restDateTimeInTZ = moment(adjustedRestTS);
      var restOpenDate = moment(adjustedOpenDateTS);
      if (!isComingSoon) return NRO_STATUS_TYPES.ALREADY_OPEN;
      if (!i18next.exists("restsearch.secondThresholdComingSoon")) return NRO_STATUS_TYPES.THRESHOLD_UNDEFINED;
      if ((restOpenDate === null || restOpenDate === void 0 ? void 0 : restOpenDate.diff(restDateTimeInTZ, "days")) > +i18next.t("restsearch.secondThresholdComingSoon")) return NRO_STATUS_TYPES.OPENS_AFTER_THRESHOLD;
      return NRO_STATUS_TYPES.OPENS_BEFORE_THRESHOLD;
    });

    _defineProperty(this, "checkIfRestaurantHoliday", function (restaurantTimeZone, closedDays, localTimestamp) {
      var isRestaurantHoliday = false;
      var closedDaysLength = closedDays === null || closedDays === void 0 ? void 0 : closedDays.length;
      var adjustedTS;
      var restCurrentDayInTZ;
      restCurrentDayInTZ = moment().tz(restaurantTimeZone).format(DATE_CONSIDERATIONS.DATE_FORMAT);

      if (localTimestamp) {
        adjustedTS = adjustServerTimestamp(localTimestamp === null || localTimestamp === void 0 ? void 0 : localTimestamp.time);
        restCurrentDayInTZ = moment(adjustedTS).format(DATE_CONSIDERATIONS.DATE_FORMAT);
      }

      for (var index = 0; index < closedDaysLength; index++) {
        var closedDay = moment(closedDays[index], "MM/DD/YYYY").format(DATE_CONSIDERATIONS.DATE_FORMAT);

        if (closedDay.valueOf() === restCurrentDayInTZ.valueOf()) {
          isRestaurantHoliday = true;
          break;
        }
      }

      return isRestaurantHoliday;
    });

    _defineProperty(this, "processRestaurantDetails", function (locations) {
      var processedRestaurantsData = [];
      var restaurantsCount = locations === null || locations === void 0 ? void 0 : locations.length;
      var currTime = moment(Date.now());

      var _loop = function _loop(idx) {
        var _restaurantDetails$lo, _restDateTimeInTZ, _restaurantDetails$we, _ref; // resetting object


        var restaurantOperatingStatus = {};
        var restaurantDetails = locations === null || locations === void 0 ? void 0 : locations[idx];
        var adjustedTS = adjustServerTimestamp(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$lo = restaurantDetails.localTimestamp) === null || _restaurantDetails$lo === void 0 ? void 0 : _restaurantDetails$lo.time);
        var restDateTimeInTZ = moment(adjustedTS);
        var timeAtResponse = moment(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.timeAtResponse);
        var differenceTime = currTime === null || currTime === void 0 ? void 0 : currTime.diff(timeAtResponse, "minutes");
        restDateTimeInTZ = (_restDateTimeInTZ = restDateTimeInTZ) === null || _restDateTimeInTZ === void 0 ? void 0 : _restDateTimeInTZ.add(differenceTime, "minutes");
        restaurantOperatingStatus.isRestaurantHoliday = _this.checkIfRestaurantHoliday(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.timeZone, restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.closedDays);
        restaurantOperatingStatus.isClosed = restaurantOperatingStatus === null || restaurantOperatingStatus === void 0 ? void 0 : restaurantOperatingStatus.isRestaurantHoliday; // handling days in [1, 7]

        var restDayInTZ = restDateTimeInTZ.day() + 1;
        var restaurantOPData = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$we = restaurantDetails.weeklyHours) === null || _restaurantDetails$we === void 0 ? void 0 : _restaurantDetails$we.filter(function (weekDetails) {
          return weekDetails.hourCode === "OP" && restDayInTZ === weekDetails.dayOfWeek;
        });
        restaurantOPData === null || restaurantOPData === void 0 ? void 0 : restaurantOPData.forEach(function (restaurantDayDetails) {
          var restaurantTimeStatus = _this.checkIfRestaurantClosed(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.localTimestamp, restaurantDayDetails === null || restaurantDayDetails === void 0 ? void 0 : restaurantDayDetails.startTime, restaurantDayDetails === null || restaurantDayDetails === void 0 ? void 0 : restaurantDayDetails.endTime);

          if (!restaurantOperatingStatus.isRestaurantHoliday) {
            restaurantOperatingStatus.isClosed = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.isRestaurantClosed;
          }

          restaurantOperatingStatus.nextOpeningTime = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.restaurantOpeningTime;
          restaurantOperatingStatus.nextClosingTime = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.restaurantClosingTime;
          restaurantOperatingStatus.isClosingSoon = _this.checkIfClosingSoon(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.localTimestamp, restaurantDayDetails === null || restaurantDayDetails === void 0 ? void 0 : restaurantDayDetails.endTime, true);
        }); //update restaurantOperatingStatus w.r.t siteLevelSplHours and locationLevelSplHours

        var siteLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.siteLevelSplHours) || [];
        var locationLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.locationLevelSplHours) || [];
        var restaurantSplHoursOPData = (_ref = [].concat(_toConsumableArray(siteLevelSplHours), _toConsumableArray(locationLevelSplHours))) === null || _ref === void 0 ? void 0 : _ref.filter(function (splHours) {
          var _splHours$hourCode;

          return (splHours === null || splHours === void 0 ? void 0 : (_splHours$hourCode = splHours.hourCode) === null || _splHours$hourCode === void 0 ? void 0 : _splHours$hourCode.hourCode) === "OP" && splHours.startDayOfWeek <= restDayInTZ && restDayInTZ <= splHours.endDayOfWeek;
        });
        restaurantSplHoursOPData === null || restaurantSplHoursOPData === void 0 ? void 0 : restaurantSplHoursOPData.forEach(function (splHour) {
          var restaurantTimeStatus = _this.checkIfRestaurantClosed(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.localTimestamp, splHour === null || splHour === void 0 ? void 0 : splHour.startTime, splHour === null || splHour === void 0 ? void 0 : splHour.endTime);

          if (!restaurantOperatingStatus.isRestaurantHoliday) {
            restaurantOperatingStatus.isClosed = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.isRestaurantClosed;
          }

          restaurantOperatingStatus.nextOpeningTime = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.restaurantOpeningTime;
          restaurantOperatingStatus.nextClosingTime = restaurantTimeStatus === null || restaurantTimeStatus === void 0 ? void 0 : restaurantTimeStatus.restaurantClosingTime;
          restaurantOperatingStatus.isClosingSoon = _this.checkIfClosingSoon(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.localTimestamp, splHour === null || splHour === void 0 ? void 0 : splHour.endTime, true);
        });

        var waitListInformation = _this.processWaitlistInformation(restDateTimeInTZ, restaurantDetails);

        processedRestaurantsData.push(_objectSpread(_objectSpread(_objectSpread({}, restaurantDetails), restaurantOperatingStatus), {}, {
          waitListInformation: waitListInformation
        }));
      };

      for (var idx = 0; idx < restaurantsCount; idx++) {
        _loop(idx);
      }

      return processedRestaurantsData;
    });

    _defineProperty(this, "checkAndGetErrorDescription", function (error) {
      var _this$cart$parseError;

      var faultOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var errObj = error;
      var faults = (_this$cart$parseError = _this.cart.parseErrors(errObj)) === null || _this$cart$parseError === void 0 ? void 0 : _this$cart$parseError.faults;
      var errorDescription = null;

      if (faults && faults[0]) {
        if (faultOverride && faults[0].faultCode === faultOverride.faultCode) {
          errorDescription = faultOverride.faultCodeDescriptionOverride;
        } else {
          errorDescription = faults[0].faultDescription;
        }
      }

      return errorDescription ? new Error(errorDescription) : null;
    });

    this.axios = axios;
    this.config = config;
    this.cart = cart;
  }

  _createClass(Common, [{
    key: "getAppAttributes",
    value: function () {
      var _getAppAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _response$data;

        var response, indicatorsMap;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.APP_INIT);

              case 2:
                response = _context.sent;
                indicatorsMap = this.createIndicatorsMap((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.indicatorsMasterList);
                response.data["indicatorsMap"] = indicatorsMap;
                return _context.abrupt("return", response.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAppAttributes() {
        return _getAppAttributes.apply(this, arguments);
      }

      return getAppAttributes;
    }()
  }, {
    key: "createIndicatorsMap",
    value: function createIndicatorsMap(indicatorsList) {
      var indicatorsMap = {};
      indicatorsList === null || indicatorsList === void 0 ? void 0 : indicatorsList.forEach(function (indicator) {
        indicatorsMap[indicator.indicatorCode] = indicator;
      });
      return indicatorsMap;
    }
  }, {
    key: "getCityStateFromZip",
    value: function () {
      var _getCityStateFromZip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(zipCode) {
        var country,
            headers,
            _yield$handle,
            _yield$handle2,
            err,
            response,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                country = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "US";
                headers = {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  "x-retry-on-timeout": true
                };
                _context2.next = 4;
                return handle(this.axios.post(this.config.postfix.ZIPCODE_QUERY, {
                  zipCode: zipCode,
                  country: country,
                  ResultMessage: "SUCCESS",
                  redirectURL: "",
                  errorURL: ""
                }, {
                  headers: headers
                }));

              case 4:
                _yield$handle = _context2.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                response = _yield$handle2[1];

                if (!err) {
                  _context2.next = 12;
                  break;
                }

                throw err;

              case 12:
                return _context2.abrupt("return", response.data);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCityStateFromZip(_x) {
        return _getCityStateFromZip.apply(this, arguments);
      }

      return getCityStateFromZip;
    }()
  }, {
    key: "getSessionAttributes",
    value: function () {
      var _getSessionAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var performMoveToPurchase,
            response,
            data,
            _data,
            _data$deliveryGroup,
            _data$deliveryGroup2,
            _data$dardenSessionCo,
            checkCreated,
            curbSideHoursStr,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                performMoveToPurchase = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
                _context3.next = 3;
                return this.axios.get(this.config.postfix.SESSION_INIT);

              case 3:
                response = _context3.sent;
                data = response.data;

                if (!data) {
                  _context3.next = 20;
                  break;
                }

                if (!performMoveToPurchase) {
                  _context3.next = 15;
                  break;
                }

                checkCreated = (_data$dardenSessionCo = data.dardenSessionContext) === null || _data$dardenSessionCo === void 0 ? void 0 : _data$dardenSessionCo.checkCreated;

                if (checkCreated) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 11;
                return handle(this.cart.moveToPurchaseFlow(true));

              case 11:
                _context3.next = 13;
                return this.axios.get(this.config.postfix.SESSION_INIT);

              case 13:
                response = _context3.sent;
                data = response.data;

              case 15:
                curbSideHoursStr = (_data = data) === null || _data === void 0 ? void 0 : _data.curbSideHours;
                delete data.curbSideHours;
                return _context3.abrupt("return", merge(data, {
                  deliveryGroup: {
                    deliveryServiceDate: (_data$deliveryGroup = data.deliveryGroup) !== null && _data$deliveryGroup !== void 0 && _data$deliveryGroup.deliveryServiceDateTime ? moment((_data$deliveryGroup2 = data.deliveryGroup) === null || _data$deliveryGroup2 === void 0 ? void 0 : _data$deliveryGroup2.deliveryServiceDateTime.time).toDate() : null
                  },
                  curbSideHours: curbSideHoursStr ? curbSideHoursStr.split("#") : curbSideHoursStr,
                  actualPickupDateTime: data.actualPickupTime ? moment(data.actualPickupTime.time).toDate() : null,
                  requestedPickupDateTime: data.requestedPickupDateTime ? moment(data.requestedPickupDateTime.time).toDate() : null,
                  deliveryServiceDateTime: data.deliveryServiceDateTime ? moment(data.deliveryServiceDateTime.time).toDate() : null,
                  isCurbSideToGoAvailable: data.isCurbSideToGoAvailable === "yes" || data.isCurbSideToGoAvailable === "true" || typeof data.isCurbSideToGoAvailable === "boolean" && data.isCurbSideToGoAvailable ? true : false
                }));

              case 20:
                return _context3.abrupt("return", data);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSessionAttributes() {
        return _getSessionAttributes.apply(this, arguments);
      }

      return getSessionAttributes;
    }()
  }, {
    key: "getGiftCardSessionAttributes",
    value: function () {
      var _getGiftCardSessionAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.axios.get(this.config.postfix.GC_SESSION_INIT);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getGiftCardSessionAttributes() {
        return _getGiftCardSessionAttributes.apply(this, arguments);
      }

      return getGiftCardSessionAttributes;
    }()
  }, {
    key: "getResourceBundles",
    value: function () {
      var _getResourceBundles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(this.config.postfix.RESOURCE_BUNDLE);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getResourceBundles() {
        return _getResourceBundles.apply(this, arguments);
      }

      return getResourceBundles;
    }()
  }, {
    key: "currentRestaurantWaitlistInformation",
    value: function currentRestaurantWaitlistInformation(restaurantDetails) {
      var _restaurantDetails$ad,
          _this2 = this;

      var timeZone = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$ad = restaurantDetails.address) === null || _restaurantDetails$ad === void 0 ? void 0 : _restaurantDetails$ad.timeZone;
      var restDateTimeInTZ = moment().tz(timeZone);

      if (restaurantDetails !== null && restaurantDetails !== void 0 && restaurantDetails.localTimestamp) {
        var _restaurantDetails$lo2;

        var adjustedTS = adjustServerTimestamp(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$lo2 = restaurantDetails.localTimestamp) === null || _restaurantDetails$lo2 === void 0 ? void 0 : _restaurantDetails$lo2.time);
        restDateTimeInTZ = moment(adjustedTS);
      }

      var waitListInformation = {};
      waitListInformation.hasWaitlistHourCode = false;
      var restHourInfo = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restHourInfo) || [];
      var siteLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.siteLevelSplHours) || [];
      var locationLevelSplHours = (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.locationLevelSplHours) || [];
      var restWLhours = [].concat(_toConsumableArray(restHourInfo), _toConsumableArray(siteLevelSplHours), _toConsumableArray(locationLevelSplHours));

      if (restaurantDetails !== null && restaurantDetails !== void 0 && restaurantDetails.webahead) {
        restWLhours.forEach(function (waitList) {
          var _waitList$hourCode2;

          if ((waitList === null || waitList === void 0 ? void 0 : (_waitList$hourCode2 = waitList.hourCode) === null || _waitList$hourCode2 === void 0 ? void 0 : _waitList$hourCode2.hourCode) === "WL") {
            waitListInformation.hasWaitlistHourCode = true;

            _this2.processWaitlistOperatingStatus(restDateTimeInTZ, waitListInformation, waitList);
          }
        });
      } else {
        waitListInformation.isAvailable = false;
      }

      return waitListInformation;
    }
  }]);

  return Common;
}();

export { Common as default };